import type { FC } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Favicon } from "@similarweb/ui-components";
import { Box, Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { percentageFilter } from "app/filters/ngFilters";
import { SourceBadge } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/components/source-badge/SourceBadge";
import type { TopicSourceType } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/components/source-badge/types";
import { DOMAIN_TOOLTIP_FILTER_BUTTON_ID } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sources-report/domain-influence/domains-map/consts";
import { TooltipValue } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sources-report/domain-influence/domains-map/DomainsMap.styled";

import { TooltipRow } from "./TooltipRow";

interface IDomainTooltipProps {
    domain: string;
    iconUrl: string;
    topicName: string;
    sourceCategory: TopicSourceType;
    sourceAuthority: number;
    urlsCount: number;
}

export const DomainTooltip: FC<IDomainTooltipProps> = ({
    domain,
    iconUrl,
    topicName,
    sourceCategory,
    sourceAuthority,
    urlsCount,
}) => {
    return (
        <Box
            minWidth="172px"
            maxWidth="272px"
        >
            <Flex
                flexDirection="column"
                gap="16px"
            >
                <Flex gap="4px">
                    <Favicon src={iconUrl} />
                    <TooltipValue
                        fontVariant="subtitle1"
                        color={colorsPalettes.carbon[500]}
                    >
                        {domain}
                    </TooltipValue>
                </Flex>
                <Flex
                    flexDirection="column"
                    gap="10px"
                >
                    <TooltipRow
                        name={translate("llm.sources_report.source_domains.tooltip.domain.topic-name")}
                        value={topicName}
                    />
                    <TooltipRow
                        name={translate("llm.sources_report.source_domains.tooltip.domain.source-category")}
                        value={<SourceBadge sources={[{ name: sourceCategory }]} />}
                    />
                    <TooltipRow
                        name={translate("llm.sources_report.source_domains.tooltip.domain.source-authority")}
                        value={percentageFilter()(sourceAuthority, 2)}
                    />
                    <TooltipRow
                        name={translate("llm.sources_report.source_domains.tooltip.domain.url-count")}
                        value={urlsCount}
                    />
                </Flex>
            </Flex>
            <Box margin="20px 0 0">
                <Text
                    id={DOMAIN_TOOLTIP_FILTER_BUTTON_ID}
                    fontVariant="button"
                    color={colorsPalettes.blue[400]}
                    cursor="pointer"
                >
                    {translate("llm.sources_report.source_domains.tooltip.domain.filter")}
                </Text>
            </Box>
        </Box>
    );
};
